import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './LoadingState.css';

export default function LoadingState({ label, cards = false, compact = false }) {
  const { t } = useLanguage();
  return (
    <div className={`loading-state${compact ? ' loading-state-compact' : ''}`}>
      <div className="loading-state-label" role="status" aria-live="polite">
        <span className="loading-state-spinner" aria-hidden="true" />
        <span>{label || t('common.loading')}</span>
      </div>
      {cards && (
        <div className="loading-state-grid" aria-hidden="true">
          {Array.from({ length: 6 }, (_, index) => (
            <div className="loading-state-card" key={index}>
              <div className="loading-state-image" />
              <div className="loading-state-line" />
              <div className="loading-state-line loading-state-line-short" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
